// PokladkaMobile — POKLÁDKA PO BYTOCH pre partiu poterov (mview_appka_v1, 17. 10. 2026). Kopíruje schválený iOS mockup
// (Kronika 1508/1513): chipy poschodí, zoznam bytov, JEDEN ŤUK = návrh „pokládka hotová“ za CELÝ BYT (Mirko 1506),
// oranžová = návrh zo stavby, zelená = office potvrdil; druhý ťuk návrh zruší (toast Späť). Denník dňa z toho vzniká na
// serveri sám (Mirko 1442) — tu o ňom nie je ani slovo. Výmery na počítači ostávajú po miestnostiach (1511).
// Backend: GET /api/vymery-stav/:pid?remeslo=potery · POST /api/vymery-stav/byt {navrh:true, hodnota} (parťák: len zákazka z Rozpisu
// a po dnešnom Príchode — 423 „Najprv Príchod“; potvrdenie ostáva kancelárii). Ceny sem nejdú (ústava 66.9; server ich parťákovi nedá).
// noc_v2 (19. 10. 2026, simulácia 1804): BEZ SIGNÁLU sa ťuk nestratí — ide do fronty v telefóne a odíde sám, keď je signál
// (rovnako ako odkaz partie); posledný zoznam bytov si telefón pamätá. Tlačidlo „Lejeme anhydrit“ = AnhydritMobile (zrkadlo appky).
// Vlastník súboru: podsession Appka.
import React, { useEffect, useState, useCallback, useRef } from 'react'
import { M } from './mockupTheme.js'   // mview_appka_v2: vzhľad = mockup v5 (Mirko 18. 10., Kronika 1585)
import { fetchAuth } from '../auth/fetchAuth.js'
import { useToast } from '../components/Toast.jsx'
import { useT } from '../i18n.js'
import AnhydritMobile from './AnhydritMobile.jsx'   // noc_v2: liaty poter po celých bytoch, protokol = podlažie (zrkadlo appky, 1699)

const KROK = 'pokladka'
const FRONTA = 'kamir_pokladka_fronta'
// slovenské tvary: 1 miestnosť, 2–4 miestnosti, 5+ miestností
const kMiest = (n) => n === 1 ? 'mobile.pokladka.miestnost1' : (n >= 2 && n <= 4 ? 'mobile.pokladka.miestnosti24' : 'mobile.pokladka.miestnosti')
const m2 = (n) => (Math.round((Number(n) || 0) * 10) / 10).toFixed(1).replace('.', ',')
const stavBytu = (b) => {
  const ms = b.miestnosti || []
  if (!ms.length) return ''
  if (ms.every(m => Number(m[KROK]) === 2)) return 'p'
  if (ms.some(m => Number(m[KROK]) === 1)) return 'n'
  return ''
}
const citaj = (k, z) => { try { const x = JSON.parse(localStorage.getItem(k) || 'null'); return x == null ? z : x } catch (_) { return z } }
const uloz = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)) } catch (_) {} }
const bezSignalu = (e) => !navigator.onLine || (e && (e.name === 'TypeError' || /Failed to fetch|NetworkError|Load failed/i.test(String(e.message || ''))))

export default function PokladkaMobile({ projectId, projectName, onSpat }) {
  const t = useT()
  const toast = useToast()
  const [d, setD] = useState(null)
  const [obj, setObj] = useState('')
  const [po, setPo] = useState('')
  const [busy, setBusy] = useState('')
  const [chyba, setChyba] = useState('')
  const [vrstvy, setVrstvy] = useState({})   // mview_appka_v2 (Mirko 1585): vrstvy 1/2/3 pri byte, predvolené 2
  const [fronta, setFronta] = useState(() => citaj(FRONTA, []))
  const [anhydrit, setAnhydrit] = useState(false)
  const [cement, setCement] = useState(false)   // tesla_cement_v1 (Mirko 19. 10. 2026): cementová partia, celý byt = len WC a kúpeľne
  const posielam = useRef(false)

  // fronta zmení obraz bytu hneď (ako odkaz partie) — server ju dostane, keď je signál
  const sFrontou = useCallback((j) => {
    const f = citaj(FRONTA, []).filter(z => z.projectId === projectId)
    if (!j || !f.length) return j
    return { ...j, byty: (j.byty || []).map(b => { const z = f.find(x => x.vymery_id === b.vymery_id); if (!z) return b
      return { ...b, miestnosti: (b.miestnosti || []).map(m => Number(m[KROK]) === 2 ? m : { ...m, [KROK]: z.hodnota ? 1 : 0 }) } }) }
  }, [projectId])

  const nacitaj = useCallback(async () => {
    if (!projectId) { setD({ byty: [], objekty: [], poschodia: [] }); return }
    try {
      const r = await fetchAuth('/api/vymery-stav/' + encodeURIComponent(projectId) + '?remeslo=potery')
      if (!r.ok) { setChyba((await r.json().catch(() => ({}))).error || ('Chyba ' + r.status)); setD({ byty: [], objekty: [], poschodia: [] }); return }
      const j = await r.json(); uloz('kamir_pokladka_' + projectId, j); setD(sFrontou(j)); setChyba('')
      setObj(o => o || (j.objekty || [])[0] || '')
    } catch (_) {
      const c = citaj('kamir_pokladka_' + projectId, null)   // noc_v2: posledný stav z telefónu
      if (c) { setD(sFrontou(c)); setObj(o => o || (c.objekty || [])[0] || ''); setChyba('Bez signálu — posledný stav z telefónu; ťuky sa odošlú samé.') }
      else { setChyba(t('mobile.pokladka.offline')); setD(x => x || { byty: [], objekty: [], poschodia: [] }) }
    }
  }, [projectId, sFrontou]) // eslint-disable-line react-hooks/exhaustive-deps

  async function posliRaw(vymery_id, hodnota, vr) {
    const r = await fetchAuth('/api/vymery-stav/byt', { method: 'POST', body: JSON.stringify({ vymery_id, remeslo: 'potery', krok: KROK, navrh: true, vrstvy: vr, hodnota: hodnota ? 1 : 0 }) })
    const j = await r.json().catch(() => ({}))
    if (!r.ok) { const e = new Error(j.error || ('Chyba ' + r.status)); e.status = r.status; throw e }
    return j
  }
  // fronta: odošle po poradí; 423 (ešte nie je Príchod na serveri) počká, iná chyba sa zahodí s hláškou, bez signálu sa skončí
  const odosliFrontu = useCallback(async () => {
    if (posielam.current) return; posielam.current = true
    try {
      let f = citaj(FRONTA, [])
      for (const z of [...f]) {
        try { await posliRaw(z.vymery_id, z.hodnota, z.vrstvy); f = f.filter(x => x !== z && !(x.vymery_id === z.vymery_id && x.t === z.t)); uloz(FRONTA, f) }
        catch (e) {
          if (bezSignalu(e)) break
          if (e.status === 423) { setChyba(e.message); break }
          f = f.filter(x => !(x.vymery_id === z.vymery_id && x.t === z.t)); uloz(FRONTA, f); toast.warn('Neuložené: ' + e.message)
        }
      }
      setFronta(citaj(FRONTA, []))
    } finally { posielam.current = false }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { odosliFrontu().then(nacitaj) }, [nacitaj, odosliFrontu])
  useEffect(() => { const on = () => { odosliFrontu().then(nacitaj) }; window.addEventListener('online', on); const iv = setInterval(() => { if (citaj(FRONTA, []).length && navigator.onLine) on() }, 30000); return () => { window.removeEventListener('online', on); clearInterval(iv) } }, [nacitaj, odosliFrontu])

  const byty = (d && d.byty) || []
  const objekty = (d && d.objekty) || []
  const poschodia = [...new Set(byty.filter(b => !obj || b.obj === obj).map(b => b.po).filter(Boolean))].sort((x, y) => (parseInt(x, 10) || 0) - (parseInt(y, 10) || 0) || String(x).localeCompare(String(y), 'sk'))
  useEffect(() => { if (poschodia.length && !poschodia.includes(po)) setPo(poschodia[0]) }, [poschodia.join('|')]) // eslint-disable-line react-hooks/exhaustive-deps
  const zobraz = byty.filter(b => (!obj || b.obj === obj) && (!po || b.po === po))
  // CELOK_DIELA_V1 (Mirko 21. 10. 2026, ksbx-appky 2602/2616): bez Výmer = celok diela; pokládku robí iná firma = len Anhydrit
  const celok = d !== null && !byty.length && !chyba
  const inaFirma = !!(d && d.pokladka_robi === 'ina_firma')

  // predvolené 2; ak byt už má vrstvy z Výmer (vymery_room_pole), ukáže ich
  const vrstvyPre = (b) => { if (vrstvy[b.vymery_id]) return vrstvy[b.vymery_id]; const z = Number(((b.miestnosti || [])[0] || {}).vrstvy) || 0; return z >= 1 && z <= 3 ? z : 2 }
  const doFronty = (b, hodnota) => {
    const f = citaj(FRONTA, []).filter(x => x.vymery_id !== b.vymery_id)
    f.push({ projectId, vymery_id: b.vymery_id, hodnota: !!hodnota, vrstvy: vrstvyPre(b), t: Date.now() })
    uloz(FRONTA, f); setFronta(f); setD(x => sFrontou(x))
  }

  async function tuk(b) {
    if (busy) return
    const st = stavBytu(b)
    if (st === 'p') { toast.warn(t('mobile.pokladka.uz_potvrdene')); return }
    const ciel = st !== 'n'   // noc_v2: výslovná hodnota — opakovaný ťuk pri slabom signáli nič nezruší
    setBusy(b.vymery_id)
    try {
      const j = await posliRaw(b.vymery_id, ciel, vrstvyPre(b))
      await nacitaj()
      const n = (b.miestnosti || []).length
      if (j.stav === 1) {
        toast.undo(t('mobile.pokladka.navrh_poslany', { byt: b.byt || b.vymery_id, miest: t(kMiest(n), { n }) + ', ' + vrstvyPre(b) + ' ' + t('mobile.pokladka.vrstvy_slovo') }), async () => { try { await posliRaw(b.vymery_id, false, vrstvyPre(b)); await nacitaj(); toast.info(t('mobile.pokladka.navrh_zruseny')) } catch (e) { if (bezSignalu(e)) doFronty(b, false); else toast.error(e.message) } }, { duration: 6000 })
      } else {
        toast.info(t('mobile.pokladka.navrh_zruseny'))
      }
      if (j.preskocene && j.preskocene.length && j.stav === 1) toast.warn(t('mobile.pokladka.preskocene', { n: j.preskocene.length }))
    } catch (e) {
      if (bezSignalu(e)) { doFronty(b, ciel); toast.info('Bez signálu — ťuk je uložený v telefóne a odošle sa sám.') }
      else toast.error(e.message)
    }
    setBusy('')
  }

  if (cement) return <CementMobile projectId={projectId} projectName={projectName} obj={obj} po={po} onSpat={() => { setCement(false); nacitaj() }} />
  if (anhydrit && celok) return <AnhydritMobile projectId={projectId} projectName={projectName} obj="" poschodia={['Celok diela']} celok plochaZakazky={(d && d.plocha_zakazky) || 0} onSpat={() => { setAnhydrit(false); nacitaj() }} />   // CELOK_DIELA_V1
  if (anhydrit) return <AnhydritMobile projectId={projectId} projectName={projectName} obj={obj} poschodia={poschodia} onSpat={() => { setAnhydrit(false); nacitaj() }} />

  const chip = (on) => ({ display: 'inline-flex', alignItems: 'center', minHeight: 44, padding: '8px 14px', margin: '0 8px 8px 0', borderRadius: 999, border: `1px solid ${on ? M.ac : M.line}`, background: on ? M.ac : M.card, color: on ? '#fff' : M.txt, fontSize: 15, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' })
  const farba = { n: M.amb, p: M.grn }
  const hint = { fontSize: 14, color: M.mut, textAlign: 'center', margin: '10px 0' }
  const caka = fronta.filter(z => z.projectId === projectId).length

  return (
    <div style={{ padding: 16, paddingBottom: 24, background: M.bg, minHeight: '100%', fontFamily: M.font, color: M.txt }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
        {onSpat ? <button type="button" onClick={onSpat} style={{ background: 'none', border: 'none', color: M.ac, fontSize: 17, fontWeight: 600, minHeight: 44, cursor: 'pointer', fontFamily: 'inherit', padding: 0 }}>‹ {t('mobile.tab.dnes')}</button> : <span />}
        <span style={{ fontSize: 17, fontWeight: 700 }}>{t('mobile.pokladka.nadpis')}</span>
        <span style={{ width: 60 }} />
      </div>
      <div style={{ color: M.mut, fontSize: 14, marginBottom: 10 }}>{projectName || projectId} · {t('mobile.pokladka.pokyn')}</div>

      {chyba && <div style={{ ...hint, color: M.red }}>{chyba}</div>}
      {caka > 0 && <div style={{ background: '#fff7ed', border: '1px solid #fed7aa', color: '#9a3412', borderRadius: 12, padding: '10px 12px', fontSize: 14, marginBottom: 10 }}>Čaká na signál: {caka} {caka === 1 ? 'ťuk' : caka < 5 ? 'ťuky' : 'ťukov'} — odošlú sa samé.</div>}
      {d === null && <div style={hint}>{t('common.loading')}</div>}
      {/* CELOK_DIELA_V1: zákazka bez Výmer nie je prekážka — robí sa ako celok diela */}
      {celok && <>
        <div style={{ background: M.card, border: `1px solid ${M.line}`, borderRadius: 16, padding: 14, fontSize: 15, lineHeight: 1.45, marginBottom: 10 }}>Zákazka nemá vo Výmeroch poschodia ani byty — robí sa ako <b>celok diela</b>. Protokol aj PDF hovoria o celku diela.{inaFirma ? ' Pokládku robí iná firma' + (d.pokladka_firma ? ' (' + d.pokladka_firma + ')' : '') + '.' : ''}</div>
        <button type="button" onClick={() => setAnhydrit(true)} style={{ width: '100%', minHeight: 60, border: 'none', borderRadius: 16, background: M.amb, color: '#fff', fontSize: 18, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', marginTop: 4 }}>Lejeme anhydrit — celok diela →</button>
      </>}
      {inaFirma && byty.length > 0 && <div style={{ background: M.card, border: `1px solid ${M.line}`, borderRadius: 16, padding: 14, fontSize: 15, lineHeight: 1.45, marginBottom: 10 }}>Pokládku robí <b>iná firma</b>{d.pokladka_firma ? ' (' + d.pokladka_firma + ')' : ''} — máš len Anhydrit.</div>}

      {objekty.length > 1 && <div style={{ marginBottom: 4 }}>{objekty.map(o => <button key={o} type="button" style={chip(obj === o)} onClick={() => setObj(o)}>{o}</button>)}</div>}
      {poschodia.length > 0 && <div style={{ marginBottom: 10 }}>{poschodia.map(p => <button key={p} type="button" style={chip(po === p)} onClick={() => setPo(p)}>{obj ? obj + ' · ' : ''}{p}</button>)}</div>}

      <div>
        {(inaFirma ? [] : zobraz).map((b, i) => {   // CELOK_DIELA_V1: iná firma = bez odškrtávania pokládky
          const st = stavBytu(b)
          const plocha = (b.miestnosti || []).reduce((a, m) => a + (Number(m.m2) || 0), 0)
          const n = (b.miestnosti || []).length
          const vFronte = fronta.some(z => z.vymery_id === b.vymery_id)
          return (
            <div key={b.vymery_id} role="button" onClick={() => tuk(b)} style={{
              display: 'flex', alignItems: 'center', gap: 14, padding: '14px 16px', minHeight: 64, background: M.card, cursor: 'pointer',
              borderBottom: i === zobraz.length - 1 ? 'none' : `1px solid ${M.field}`, borderRadius: i === 0 ? '16px 16px 0 0' : i === zobraz.length - 1 ? '0 0 16px 16px' : 0,
              border: `1px solid ${M.line}`, borderTop: i === 0 ? `1px solid ${M.line}` : 'none', opacity: st === 'p' ? 0.7 : 1,
            }}>
              <div style={{ width: 34, height: 34, borderRadius: 10, flexShrink: 0, border: `2px solid ${st ? farba[st] : '#C5CCD6'}`, background: st ? farba[st] : 'transparent', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 18 }}>{st ? '✓' : ''}</div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 700, fontSize: 19 }}>{t('mobile.pokladka.byt')} {b.byt || b.vymery_id}</div>
                <div style={{ fontSize: 14, color: M.mut }}>
                  {t(kMiest(n), { n })} · {st === 'p' ? t('mobile.pokladka.potvrdene') : st === 'n' ? t('mobile.pokladka.navrh') : t('mobile.pokladka.pokladka')}
                  {vFronte ? ' · čaká na signál' : ''}
                  {busy === b.vymery_id ? ' …' : ''}
                </div>
                {st !== 'p' && (
                  <div style={{ display: 'inline-flex', gap: 4, marginTop: 6, alignItems: 'center' }} onClick={e => e.stopPropagation()}>
                    <span style={{ fontSize: 12, color: M.mut, marginRight: 4 }}>{t('mobile.pokladka.vrstvy')}</span>
                    {[1, 2, 3].map(v => <button key={v} type="button" style={{ minWidth: 38, minHeight: 32, borderRadius: 8, border: `1px solid ${vrstvyPre(b) === v ? M.ac : M.line}`, background: vrstvyPre(b) === v ? M.ac : '#fff', color: vrstvyPre(b) === v ? '#fff' : M.txt, fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }} onClick={() => setVrstvy(x => ({ ...x, [b.vymery_id]: v }))}>{v}×</button>)}
                  </div>
                )}
              </div>
              <div style={{ color: M.mut, fontSize: 14, whiteSpace: 'nowrap' }}>{m2(plocha)} m²</div>
            </div>
          )
        })}
      </div>
      {!inaFirma && !celok && <div style={hint}>{t('mobile.pokladka.legenda')}</div>}
      {d !== null && byty.length > 0 && <>
        {/* noc_v2 (Mirko 18. 10. 2026, 1611–1672): liaty poter — len tam, kde office potvrdil pokládku; protokol jedno podlažie */}
        <button type="button" onClick={() => setAnhydrit(true)} style={{ width: '100%', minHeight: 60, border: 'none', borderRadius: 16, background: M.amb, color: '#fff', fontSize: 18, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', marginTop: 4 }}>Lejeme anhydrit →</button>
        <div style={hint}>{inaFirma ? 'Pokládku robí iná firma — anhydrit sa leje bez potvrdenia pokládky. ' : 'Anhydrit sa leje len tam, kde office potvrdil pokládku. '}Protokol je jeden na poschodie.{d.cement_mokre ? ' Na tejto zákazke sa vo WC a kúpeľniach anhydrit neleje.' : ''}</div>
        {!!d.cement_mokre && <button type="button" onClick={() => setCement(true)} style={{ width: '100%', minHeight: 56, border: `2px solid ${M.line}`, borderRadius: 16, background: M.card, color: M.txt, fontSize: 17, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', marginTop: 4 }}>Liali sme cementový poter (WC, kúpeľne) →</button>}
      </>}
    </div>
  )
}


// tesla_cement_v1 (Mirko 19. 10. 2026, Kronika 2008, 2010): cementový poter vo WC a kúpeľniach (len zákazka so zapnutým
// príznakom, Tesla). Jeden ťuk = návrh „liate“ za celý byt — server zapíše LEN WC a kúpeľne (POST /byt druh 'cement');
// rozsah a plochu dáva server (GET /rozsah?druh=cement). Potvrdenie ostáva kancelárii.
function CementMobile({ projectId, projectName, obj, po, onSpat }) {
  const toast = useToast()
  const [r, setR] = useState(null)
  const [busy, setBusy] = useState('')
  const nacitaj = useCallback(async () => {
    try {
      const x = await fetchAuth('/api/vymery-stav/' + encodeURIComponent(projectId) + '/rozsah?' + new URLSearchParams({ obj: obj || '', po: po || '', druh: 'cement' }))
      const j = await x.json(); if (!x.ok) { toast.error(j.error || ('Chyba ' + x.status)); setR({ byty: [] }); return }
      setR(j)
    } catch (e) { toast.error(e.message); setR({ byty: [] }) }
  }, [projectId, obj, po]) // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { nacitaj() }, [nacitaj])
  async function tuk(b) {
    if (busy || b.anhydrit === 2) return
    if (!b.pokladka_potvrdena) { toast.warn('V tomto byte office ešte nepotvrdil pokládku.'); return }
    setBusy(b.vymery_id)
    try {
      const x = await fetchAuth('/api/vymery-stav/byt', { method: 'POST', body: JSON.stringify({ vymery_id: b.vymery_id, remeslo: 'potery', krok: 'anhydrit', navrh: true, hodnota: b.anhydrit === 1 ? 0 : 1, druh: 'cement' }) })
      const j = await x.json().catch(() => ({}))
      if (!x.ok) toast.error(j.error || ('Chyba ' + x.status))
      else toast.info(j.stav === 1 ? 'Byt ' + (b.byt || '') + ': cementový poter poslaný na potvrdenie (WC a kúpeľne).' : 'Návrh zrušený.')
      await nacitaj()
    } catch (e) { toast.error(e.message) }
    setBusy('')
  }
  const byty = (r && r.byty) || []
  return (
    <div style={{ padding: 16, paddingBottom: 24, background: M.bg, minHeight: '100%', fontFamily: M.font, color: M.txt }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
        <button type="button" onClick={onSpat} style={{ background: 'none', border: 'none', color: M.ac, fontSize: 17, fontWeight: 600, minHeight: 44, cursor: 'pointer', fontFamily: 'inherit', padding: 0 }}>‹ Pokládka</button>
        <span style={{ fontSize: 17, fontWeight: 700 }}>Cementový poter</span>
        <span style={{ width: 60 }} />
      </div>
      <div style={{ color: M.mut, fontSize: 14, marginBottom: 10 }}>{projectName || projectId} · {obj ? obj + ' · ' : ''}{po} · ťukni byt = liali sme WC a kúpeľne</div>
      {r === null && <div style={{ fontSize: 14, color: M.mut, textAlign: 'center' }}>Načítavam…</div>}
      {r !== null && !byty.length && <div style={{ fontSize: 14, color: M.mut, textAlign: 'center' }}>Na tomto poschodí nie sú WC ani kúpeľne.</div>}
      {byty.map((b, i) => {
        const farba = b.anhydrit === 2 ? M.grn : b.anhydrit === 1 ? M.amb : '#C5CCD6'
        return (
          <div key={b.vymery_id} role="button" onClick={() => tuk(b)} style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '14px 16px', minHeight: 64, background: M.card, cursor: 'pointer', border: `1px solid ${M.line}`, borderTop: i === 0 ? `1px solid ${M.line}` : 'none', borderRadius: i === 0 ? '16px 16px 0 0' : i === byty.length - 1 ? '0 0 16px 16px' : 0, opacity: b.anhydrit === 2 ? 0.7 : 1 }}>
            <div style={{ width: 34, height: 34, borderRadius: 10, border: `2px solid ${farba}`, background: b.anhydrit ? farba : 'transparent', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 18 }}>{b.anhydrit ? '✓' : ''}</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: 19 }}>Byt {b.byt || b.vymery_id}</div>
              <div style={{ fontSize: 14, color: M.mut }}>{b.miestnosti_n} {b.miestnosti_n === 1 ? 'miestnosť' : b.miestnosti_n < 5 ? 'miestnosti' : 'miestností'} · {m2(b.m2)} m² · {b.anhydrit === 2 ? 'potvrdené' : b.anhydrit === 1 ? 'návrh' : b.pokladka_potvrdena ? 'na liatie' : 'pokládka nepotvrdená'}{busy === b.vymery_id ? ' …' : ''}</div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
